import template from './settingsForm.html';
import './settingsForm.scss';

class SettingsFormController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
    this.userInfo = {
      name: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    };

    this.errors = Object.assign({ all: '' }, this.userInfo);
    this.errorsRegex = {
      incorrectPassword: /the current password is incorrect/i,
      usedEmail: /a user account with .*? already exists\.$/i,
    };
  }
  $onInit() {
    this.userInfo.name = this.userName;
    this.userInfo.email = this.userEmail;
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      if (this.errorsRegex.incorrectPassword.test(error.currentValue)) {
        this.errors.currentPassword = error.currentValue;
      } else if (this.errorsRegex.usedEmail.test(error.currentValue)) {
        this.errors.email = 'A user account with this email address already exists.';
      } else {
        this.errors.all = error.currentValue;
      }
    }
  }
  cancel() {
    this.onCancel();
  }
  save() {
    if (!this.loading) {
      this._resetErrors();
      const { form } = this;

      const {
        currentPassword,
        newPassword,
        confirmNewPassword,
      } = this.userInfo;

      const changingPassword = !!(newPassword || confirmNewPassword);

      if (form.$valid) {
        this.errors.name = '';
        this.errors.email = '';
        if (changingPassword) {
          this._validatePasswordChange(
            currentPassword,
            newPassword,
            confirmNewPassword,
          );
        } else {
          this.onSave(this.userInfo);
        }
      } else if (form.$error.email) {
        this.errors.email = 'Please enter a valid e-mail address';
      } else {
        this._markErrorOnRequiredFields();
      }
    }
  }
  get form() {
    return this.$scope.nzSettingsForm_form;
  }
  _validatePasswordChange(
    currentPassword,
    newPassword,
    confirmNewPassword,
  ) {
    const allPasswords = !!(newPassword && confirmNewPassword);
    if (allPasswords) {
      const newPasswordError = this.validatePassword({
        password: newPassword,
      });
      if (newPasswordError) {
        this.errors.newPassword = newPasswordError;
      } else if (newPassword !== confirmNewPassword) {
        this.errors.confirmNewPassword = 'The passwords don\'t match';
      } else {
        this.onSave(this.userInfo);
      }
    } else {
      this._markErrorOnPasswordRequiredFields();
    }
  }
  _resetErrors() {
    Object.keys(this.errors).forEach((fieldName) => {
      this.errors[fieldName] = '';
    });
  }
  _markErrorOnRequiredFields() {
    ['name', 'email']
    .forEach((fieldName) => {
      this.errors[fieldName] = this.userInfo[fieldName] ?
        '' :
        'Please complete this field';
    });
  }
  _markErrorOnPasswordRequiredFields() {
    ['newPassword', 'confirmNewPassword']
    .forEach((fieldName) => {
      this.errors[fieldName] = this.userInfo[fieldName] ?
        '' :
        'Please complete this field if you want to change your password';
    });
  }
}

export default {
  controller: SettingsFormController,
  template,
  bindings: {
    loading: '<',
    error: '<',
    userName: '<',
    userEmail: '<',
    validatePassword: '&',
    onSave: '&',
    onCancel: '&',
  },
};
